import React from 'react';
import { MetricGreetingCard } from '../../components/metricGreetingCard/MetricGreetingCard';

type MyMetricGreetingProps = {
    employeeName: string;
    totalMetricsAttained: number;
    totalMetricsReported: number;
    totalMetricsTargeted: number;
    // P4P multi-tier (E20-6317): passed straight through to MetricGreetingCard.
    scorecardCalculationRuleId?: number | null;
};

export const MyMetricGreeting = ({
    employeeName,
    totalMetricsAttained,
    totalMetricsReported,
    totalMetricsTargeted,
    scorecardCalculationRuleId,
}: MyMetricGreetingProps) => {

    return (
        <div>
            {employeeName?.length > 0 && (
                <div className="row mt-4">
                    <div className="col-12">
                        <MetricGreetingCard
                            employeeName={employeeName}
                            totalMetricsAttained={totalMetricsAttained}
                            totalMetricsReported={totalMetricsReported}
                            totalMetricsTargeted={totalMetricsTargeted}
                            scorecardCalculationRuleId={scorecardCalculationRuleId}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
